import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { NotificationToastService } from '../../../services/notification-toast.service';
import { PatientAssignationService } from '../../../services/patient-assignation.service';

export class PatientCrmAssigmentBudgetTimeResponse {
  budgetTime?: number; 
}

export class PatientCrmAssigmentBudgetTimeRequest {
  budgetTime?: number;
  patientId: number;
}

@Component({
  selector: 'app-patient-crm-assigment-budget-time-dialog',
  templateUrl: './patient-crm-assigment-budget-time-dialog.component.html',
  styleUrls: ['./patient-crm-assigment-budget-time-dialog.component.css']
})
export class PatientCrmAssigmentBudgetTimeDialogComponent  {
 
  form: FormGroup;
  loading: boolean;

  constructor( 
               private formBuilder: FormBuilder,
               public dialogRef: MatDialogRef<PatientCrmAssigmentBudgetTimeDialogComponent>,
               private notificationToastService: NotificationToastService,
               private patientAssignationService: PatientAssignationService,
               @Inject(MAT_DIALOG_DATA) public data: PatientCrmAssigmentBudgetTimeRequest) {

    this.form = this.formBuilder.group({
      budgetTime: [data.budgetTime, Validators.required], 
    });
 

  }

  get f() { return this.form.controls; }
 
  onNoClick(): void {
    this.dialogRef.close(null);
  }

  async save() {
    try {
      if (!this.form.invalid) {
        this.loading = true;
        await this.patientAssignationService
          .assignBudgetTime(
              this.data.patientId,
              this.form.controls.budgetTime.value);

        this.dialogRef.close({
          budgetTime: this.form.controls.budgetTime.value, 
        });

      }
    } catch (err) {
      console.log(err);
      this.notificationToastService.error(JSON.stringify(err.error), 'Asignación de horas presupuestadas');
    } finally {
      this.loading = false;
    }
  }

}
